if(!customElements.get('mc-cart-drawer'))customElements.define('mc-cart-drawer',class extends HTMLElement{
  connectedCallback(){
    this.panel=this.querySelector('[role=dialog]');
    this.items=this.querySelector('.mc-cart-drawer__items');
    this.error=this.querySelector('[role=alert]');
    this.addEventListener('click',event=>{
      if(event.target.closest('[data-mc-cart-close]'))this.close();
      const remove=event.target.closest('[data-mc-remove-key]');
      if(remove)this.change(remove.dataset.mcRemoveKey,0);
    });
    this.addEventListener('change',event=>{
      if(event.target.matches('[data-mc-quantity-key]')){
        if(event.target.reportValidity())this.change(event.target.dataset.mcQuantityKey,Number(event.target.value));
      }
    });
    this.addEventListener('keydown',event=>{
      if(event.key==='Escape' && !document.querySelector('product-modal[open]')){event.stopPropagation();this.close();}
    });
  }
  endpoint(path){
    const root=window.Shopify?.routes?.root || '/';
    return new URL(root+path,location.origin).href;
  }
  async open(trigger){
    this.returnFocus=trigger;
    this.previousOverflow=document.documentElement.style.overflow;
    this.hidden=false;document.documentElement.style.overflow='hidden';
    this.error.hidden=true;this.panel.setAttribute('aria-busy','true');
    trapFocus(this.panel,this.panel);
    try{const response=await fetch(this.endpoint('cart.js'),{headers:{Accept:'application/json'}});if(!response.ok)throw Error('Cart unavailable');this.render(await response.json());}
    catch{this.error.textContent=this.dataset.errorLabel;this.error.hidden=false;}
    finally{this.panel.removeAttribute('aria-busy');}
  }
  close(){
    if(this.hidden)return;
    this.hidden=true;document.documentElement.style.overflow=this.previousOverflow;
    removeTrapFocus(this.returnFocus);
  }
  node(tag,className,text){
    const node=document.createElement(tag);if(className)node.className=className;if(text!=null)node.textContent=text;return node;
  }
  render(cart){
    this.cart=cart;this.items.replaceChildren();
    if(!cart.items.length)this.items.append(this.node('p','',this.dataset.emptyLabel));
    for(const item of cart.items){
      const row=this.node('div','mc-cart-drawer__item');row.dataset.mcCartKey=item.key;
      const image=this.node('img','mc-cart-drawer__image');image.alt=item.product_title;image.width=88;image.height=112;
      const src=item.featured_image?.url || item.image;
      if(src)image.src=new URL(src,location.origin).href;
      else image.hidden=true;
      const imageButton=this.node('button','mc-cart-drawer__image-button mc-image-zoom-trigger');imageButton.type='button';imageButton.setAttribute('aria-label',this.dataset.imageLabel);
      if(src){const zoom=new URL(src,location.origin);zoom.searchParams.set('width','2048');imageButton.dataset.mcImageZoom=zoom.href;imageButton.dataset.mcImageWidth=String(Math.min(2048,item.featured_image?.width || 2048));imageButton.dataset.mcImageAlt=item.product_title;}
      else imageButton.disabled=true;
      imageButton.append(image);row.append(imageButton);
      const details=this.node('div','mc-cart-drawer__details');
      const title=this.node('a','mc-cart-drawer__name',item.product_title);title.href=item.url;details.append(title);
      const typeRow=this.node('div','mc-cart-type');typeRow.append(document.createTextNode(this.dataset.typeLabel+': '));const typeValue=this.node('span');typeValue.dataset.mcTypeValue='';typeRow.append(typeValue);details.append(typeRow);mcCartType.populate(item,typeValue,title);
      const options=this.node('div','mc-cart-drawer__options');
      for(const option of item.options_with_values || [])if(option.name!=='Choose Product' && option.value && option.value!=='Default Title')options.append(this.node('div','',`${option.name}: ${option.value}`));
      details.append(options,this.node('strong','mc-cart-drawer__price',mcCartTotals.money(item.final_line_price,cart.currency)));
      const controls=this.node('div','mc-cart-drawer__quantity');
      const input=this.node('input');input.type='number';input.min=String(item.quantity_rule?.min || 1);input.step=String(item.quantity_rule?.increment || 1);if(item.quantity_rule?.max!=null)input.max=String(item.quantity_rule.max);input.value=String(item.quantity);input.dataset.mcQuantityKey=item.key;input.setAttribute('aria-label',`${this.dataset.quantityLabel}: ${item.product_title}`);
      const remove=this.node('button','mc-cart-drawer__remove');remove.type='button';remove.dataset.mcRemoveKey=item.key;remove.setAttribute('aria-label',this.dataset.removeLabel);remove.append(this.querySelector('[data-mc-remove-icon]').content.cloneNode(true));
      controls.append(input,remove);details.append(controls);row.append(details);this.items.append(row);
    }
    mcCartTotals.update(cart);window.mcDelivery?.update(this);
  }
  async change(key,quantity){
    if(this.panel.getAttribute('aria-busy')==='true')return;
    const focusKey=key;this.error.hidden=true;this.panel.setAttribute('aria-busy','true');
    try{
      const response=await fetch(this.endpoint('cart/change.js'),{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity,sections:['cart-icon-bubble'],sections_url:location.pathname})});
      const cart=await response.json();if(!response.ok || cart.errors)throw Error(cart.description || cart.errors || this.dataset.errorLabel);
      this.render(cart);
      const bubble=document.getElementById('cart-icon-bubble');
      const source=cart.sections?.['cart-icon-bubble'] && new DOMParser().parseFromString(cart.sections['cart-icon-bubble'],'text/html').querySelector('.shopify-section');
      if(bubble && source)bubble.innerHTML=source.innerHTML;
      if(typeof publish==='function')publish(PUB_SUB_EVENTS.cartUpdate,{source:'mc-cart-drawer',cartData:cart});
      const target=[...this.querySelectorAll('[data-mc-quantity-key]')].find(el=>el.dataset.mcQuantityKey===focusKey) || this.panel;
      trapFocus(this.panel,target);
    }catch(error){this.error.textContent=error.message;this.error.hidden=false;this.render(this.cart);}
    finally{this.panel.removeAttribute('aria-busy');}
  }
});
